import React from 'react'
import InputSearchProps from '../inputProps';
import * as Style from './style';
import * as Images from '../../../../images';
import * as Comp from '../../../../Components/Form';
const RightPart = () => {
    return (
        <Style.RightSection>
            <Style.ChatPart >
                <Style.ChatMsg>
                    <Style.MsgImage>
                        <Style.Image src={Images.supImg} />
                    </Style.MsgImage>
                    <Style.MsgTime>
                        5:12 م
                    </Style.MsgTime>
                </Style.ChatMsg>
                <Style.ChatMsg type="sup">
                    <Style.MsgText>
                        تظل الفلسفات التربوية وأهدافها مجردات
                    </Style.MsgText>
                    <Style.MsgTime>
                        5:12 م
                    </Style.MsgTime>
                </Style.ChatMsg>
                <Style.ChatMsg>
                    <Style.MsgText>
                        تظل الفلسفات التربوية وأهدافها مجردات ما لم تجد طريقها إلى المناهج التعليمية التي تعمل
                    </Style.MsgText>
                    <Style.MsgTime>
                        5:12 م
                    </Style.MsgTime>
                </Style.ChatMsg>
                <Style.ChatMsg>
                    <Style.MsgText>
                        تظل الفلسفات التربوية وأهدافها مجردات ما لم تجد طريقها
                    </Style.MsgText>
                    <Style.MsgTime>
                        5:12 م
                    </Style.MsgTime>
                </Style.ChatMsg>
            </Style.ChatPart>
            <Comp.InputFail 
                placeholder="أدخل رسالتك هنا..."
                height='48px'
                width='100%'
                name='full_name'
                inputProps={InputSearchProps}
            />
        </Style.RightSection>
    )
}

export default RightPart